import CompanyService from "../../../../../../services/company.service";
import { store } from "../../../../../../store";
import { QUOTE_CONFIRM_INCORPORATION_DATE_LOCK } from "../../../../../../actions/types";

export default async function validateIncorporationDate({
    quoteId,
    uen,
    incorporationDate,
    setShowPopupD,
    setShowPopupE,
    onIncorporationDateValidationChange,
    setValidationError,
    isCurrent = () => true
}) {
    const fallbackMessage = "Unable to validate the incorporation date. Please try again.";

    if (quoteId == null || `${quoteId}`.trim() === "") {
        if (isCurrent()) {
            setValidationError?.(fallbackMessage);
            onIncorporationDateValidationChange?.(false);
        }
        return;
    }

    try {
        console.log("Validating incorporation date with quoteId:", quoteId, "uen:", uen, "incorporationDate:", incorporationDate);
        await CompanyService.validateIncorporationDate(quoteId, uen, incorporationDate);

        if (isCurrent() && store.getState().quote.id === quoteId) {
            store.dispatch({ type: QUOTE_CONFIRM_INCORPORATION_DATE_LOCK, payload: false });
            setValidationError?.("");
            onIncorporationDateValidationChange?.(true);
        }
    } catch (error) {
        if (!isCurrent()) {
            return;
        }

        const errorMessage = error?.message?.toLowerCase();
        onIncorporationDateValidationChange?.(false);

        if (errorMessage?.includes("incorporation date must be earlier or same as policy effective date")) {
            setShowPopupD(true);
        } else if (errorMessage?.includes("incorporation date differs from system record")) {
            setShowPopupE(true);
        } else {
            setValidationError?.(fallbackMessage);
        }
    }
}